(function () {
  'use strict';

  /* Mobile navigation */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function updateProductMainImage(mainImage, options) {
    if (!mainImage || !options.src) return;
    mainImage.src = options.src;
    if (options.srcset) {
      mainImage.srcset = options.srcset;
    } else {
      mainImage.removeAttribute('srcset');
    }
    if (options.alt !== undefined) {
      mainImage.alt = options.alt || '';
    }
  }

  /* Product page: variant selection, price & gallery */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product = JSON.parse(jsonEl.textContent);
    var variantInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var stockEl = document.querySelector('[data-product-stock]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var mainImage = document.querySelector('[data-product-main-image]');
    var thumbs = document.querySelectorAll('[data-product-thumb]');

    function findVariant() {
      var selected = [];

      product.options.forEach(function (_, index) {
        var input = form.querySelector('[data-option-index="' + index + '"]:checked');
        if (!input) {
          input = form.querySelector('select[data-option-index="' + index + '"]');
        }
        if (input) selected.push(input.value);
      });

      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      var format = window.loyaliceMoneyFormat || '${{amount}}';
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    }

    var saveEl = document.querySelector('[data-product-save]');
    var saveTemplate = saveEl ? saveEl.dataset.saveTemplate : '';

    function updateSaveAmount(variant) {
      if (!saveEl) return;
      if (variant.compare_at_price > variant.price) {
        var saveCents = variant.compare_at_price - variant.price;
        if (saveTemplate) {
          saveEl.textContent = saveTemplate.replace('[amount]', formatMoney(saveCents));
        } else {
          saveEl.textContent = formatMoney(saveCents);
        }
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    function updateVariantUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;

      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') === String(variant.id)) return;
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({ variantId: variant.id }, '', url.pathname + url.search + url.hash);
      } catch (e) {
        /* Ignore URL update failures in older browsers */
      }
    }

    function updateUI(variant) {
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      updateVariantUrl(variant);

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.closest('.price')?.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
      }

      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      updateSaveAmount(variant);

      if (stockEl) {
        if (variant.available) {
          stockEl.textContent = stockEl.dataset.inStockText || 'In stock';
          stockEl.className = 'product-main__stock product-main__stock--in';
        } else {
          stockEl.textContent = stockEl.dataset.outStockText || 'Sold out';
          stockEl.className = 'product-main__stock product-main__stock--out';
        }
      }

      if (addBtn) {
        var labelEl = addBtn.querySelector('[data-add-to-cart-label]') || addBtn;
        addBtn.disabled = !variant.available;
        if (variant.available) {
          var addText = addBtn.dataset.addText || 'Add to cart';
          var showPrice = addBtn.dataset.showPrice !== 'false';
          labelEl.textContent = showPrice ? addText + ' • ' + formatMoney(variant.price) : addText;
        } else {
          labelEl.textContent = addBtn.dataset.soldOutText || 'Sold out';
        }
      }

      var imageId = variant.featured_image ? variant.featured_image.id : null;
      var matchingThumb = null;

      thumbs.forEach(function (thumb) {
        var isActive = imageId && thumb.dataset.imageId == imageId;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) matchingThumb = thumb;
      });

      if (mainImage && matchingThumb) {
        updateProductMainImage(mainImage, {
          src: matchingThumb.dataset.src,
          srcset: matchingThumb.dataset.srcset,
          alt: matchingThumb.dataset.alt
        });
      } else if (mainImage) {
        if (variant.featured_image && variant.featured_image.src) {
          updateProductMainImage(mainImage, {
            src: variant.featured_image.src,
            alt: variant.featured_image.alt || ''
          });
        } else if (imageId && product.media) {
          var media = product.media.find(function (m) { return m.id === imageId; });
          if (media && media.preview_image && media.preview_image.src) {
            updateProductMainImage(mainImage, {
              src: media.preview_image.src,
              alt: media.alt || ''
            });
          }
        }
      }
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () { updateUI(findVariant()); });
    });

    updateUI(findVariant());
  }

  function initProductGallery() {
    var mainImage = document.querySelector('[data-product-main-image]');
    var thumbs = document.querySelectorAll('[data-product-thumb]');

    thumbs.forEach(function (thumb) {
      if (thumb.dataset.galleryInit === 'true') return;
      thumb.dataset.galleryInit = 'true';

      thumb.addEventListener('click', function () {
        updateProductMainImage(mainImage, {
          src: thumb.dataset.src,
          srcset: thumb.dataset.srcset,
          alt: thumb.dataset.alt
        });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var wrap = document.querySelector('[data-product-gallery-thumbs]');
    if (!wrap) return;

    var viewport = wrap.querySelector('[data-gallery-thumbs-viewport]');
    var track = wrap.querySelector('[data-gallery-thumbs-track]');
    var prevBtn = wrap.querySelector('[data-gallery-thumb-prev]');
    var nextBtn = wrap.querySelector('[data-gallery-thumb-next]');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    var thumbs = track.querySelectorAll('.product-gallery__thumb');
    if (thumbs.length <= 6) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      return;
    }

    function getScrollStep() {
      var thumb = thumbs[0];
      if (!thumb) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 8;
      return thumb.offsetHeight + gap;
    }

    function updateNav() {
      var maxScroll = track.scrollHeight - viewport.clientHeight;
      prevBtn.disabled = viewport.scrollTop <= 1;
      nextBtn.disabled = viewport.scrollTop >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      viewport.scrollTop -= getScrollStep();
      updateNav();
    });

    nextBtn.addEventListener('click', function () {
      viewport.scrollTop += getScrollStep();
      updateNav();
    });

    viewport.addEventListener('scroll', updateNav);
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  /* Collection filters form auto-submit */
  function initCollectionFilters() {
    var filterForm = document.querySelector('[data-collection-filters]');
    if (!filterForm) return;

    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () { filterForm.submit(); });
    });

    filterForm.querySelectorAll('[data-filter-group]').forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        filterForm.querySelectorAll('[data-filter-group]').forEach(function (other) {
          if (other !== group) other.open = false;
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (filterForm.contains(e.target)) return;
      filterForm.querySelectorAll('[data-filter-group][open]').forEach(function (group) {
        group.open = false;
      });
    });

    filterForm.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  function initMegamenu() {
    document.querySelectorAll('[data-megamenu-trigger]').forEach(function (trigger) {
      var item = trigger.closest('.site-header__menu-item--megamenu');
      if (!item) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function initAccountModal() {
    var modal = document.querySelector('[data-account-modal]');
    var openBtn = document.querySelector('[data-account-open]');
    if (!modal || !openBtn) return;

    var stringsEl = document.querySelector('[data-account-modal-strings]');
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    var closeBtns = modal.querySelectorAll('[data-account-close]');
    var views = modal.querySelectorAll('[data-account-view]');
    var showRegisterBtn = modal.querySelector('[data-account-show-register]');
    var showLoginBtn = modal.querySelector('[data-account-show-login]');
    var loginForm = modal.querySelector('.account-modal__form--login');
    var registerForm = modal.querySelector('.account-modal__form--register');
    var drawer = modal.querySelector('[data-account-drawer]');
    var accountMode = modal.dataset.accountMode || 'legacy';
    var storefrontLoginUrl = modal.dataset.accountLoginUrl || '/customer_authentication/login';
    var emailHintInput = modal.querySelector('[data-account-email-hint]');
    var shopifyLoginLinks = modal.querySelectorAll('[data-account-shopify-login], [data-account-shopify-register]');
    var lastFocus = null;
    var isSubmitting = false;

    function openModal(viewName) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.body.classList.add('account-modal-open');
      if (viewName) switchView(viewName);
      if (drawer) drawer.focus();
      var activeView = modal.querySelector('[data-account-view]:not([hidden])');
      var firstInput = activeView ? activeView.querySelector('input:not([type="hidden"])') : null;
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('account-modal-open');
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 280);
      if (lastFocus) lastFocus.focus();
    }

    function switchView(name) {
      views.forEach(function (view) {
        var active = view.dataset.accountView === name;
        view.classList.toggle('is-active', active);
        view.hidden = !active;
      });
    }

    function showFormErrors(form, messageHtml) {
      var errorEl = form.querySelector('[data-account-form-errors]');
      if (!errorEl) return;
      if (messageHtml) {
        errorEl.innerHTML = messageHtml;
        errorEl.hidden = false;
      } else {
        errorEl.innerHTML = '';
        errorEl.hidden = true;
      }
    }

    function extractFormErrors(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var errorNodes = doc.querySelectorAll('.errors, .form__message, [data-account-form-errors]');

      for (var i = 0; i < errorNodes.length; i++) {
        if (errorNodes[i].textContent.trim()) {
          return errorNodes[i].innerHTML;
        }
      }

      return '';
    }

    function submitCustomerForm(form, options) {
      if (isSubmitting) return Promise.resolve();
      isSubmitting = true;

      var submitBtn = form.querySelector('[data-account-submit]');
      showFormErrors(form, '');

      if (submitBtn) submitBtn.disabled = true;

      return fetch(form.action, {
        method: form.method || 'POST',
        body: new URLSearchParams(new FormData(form)),
        headers: {
          Accept: 'text/html,application/xhtml+xml',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        redirect: 'follow'
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { url: response.url, html: html };
          });
        })
        .then(function (result) {
          var errorsHtml = extractFormErrors(result.html);

          if (errorsHtml) {
            showFormErrors(form, errorsHtml);
            if (options.isRegister) switchView('register');
            return;
          }

          if (options.isRegister && result.url.indexOf('/account/register') !== -1) {
            var registerErrors = extractFormErrors(result.html);
            if (registerErrors) {
              showFormErrors(form, registerErrors);
              switchView('register');
              return;
            }
          }

          if (options.isLogin && result.url.indexOf('/account/login') !== -1) {
            var loginErrors = extractFormErrors(result.html);
            if (loginErrors) {
              showFormErrors(form, loginErrors);
              switchView('login');
              return;
            }
          }

          closeModal();
          window.location.href = options.successUrl || '/account';
        })
        .catch(function () {
          showFormErrors(
            form,
            '<ul><li>' + escapeHtml(strings.submitError || 'Something went wrong. Please try again.') + '</li></ul>'
          );
        })
        .finally(function () {
          isSubmitting = false;
          if (submitBtn) submitBtn.disabled = false;
        });
    }

    openBtn.addEventListener('click', function () {
      openModal('login');
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (showRegisterBtn) {
      showRegisterBtn.addEventListener('click', function () {
        switchView('register');
        var firstInput = registerForm ? registerForm.querySelector('input:not([type="hidden"])') : null;
        if (firstInput) firstInput.focus();
      });
    }

    if (showLoginBtn) {
      showLoginBtn.addEventListener('click', function () {
        switchView('login');
        var firstInput = loginForm ? loginForm.querySelector('input:not([type="hidden"])') : null;
        if (firstInput) firstInput.focus();
      });
    }

    function buildShopifyLoginUrl() {
      if (storefrontLoginUrl.indexOf('customer_authentication') === -1) {
        return storefrontLoginUrl;
      }

      var returnTo = window.location.pathname + window.location.search;
      return '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo);
    }

    shopifyLoginLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetUrl = buildShopifyLoginUrl();

        if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
          event.preventDefault();
          window.alert(
            'Customer sign-in is not available on localhost.\n\n' +
            'Open your theme preview on your .myshopify.com store URL to test login.'
          );
          return;
        }

        if (link.getAttribute('href') !== targetUrl) {
          link.setAttribute('href', targetUrl);
        }
      });
    });

    if (loginForm) {
      loginForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!loginForm.checkValidity()) {
          loginForm.reportValidity();
          return;
        }
        submitCustomerForm(loginForm, { isLogin: true, successUrl: '/account' });
      });
    }

    if (registerForm) {
      registerForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!registerForm.checkValidity()) {
          registerForm.reportValidity();
          return;
        }
        submitCustomerForm(registerForm, { isRegister: true, successUrl: '/account' });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (modal.hasAttribute('data-account-open-on-load')) {
      openModal(modal.dataset.accountOpenView || 'register');
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('account_error');
        url.searchParams.delete('account_tab');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    }
  }

  function initProductCards() {
    document.querySelectorAll('[data-product-card]:not([data-product-card-init])').forEach(function (card) {
      card.setAttribute('data-product-card-init', '');
      var slides = card.querySelectorAll('[data-product-card-slide]');
      if (slides.length <= 1) return;

      var dots = card.querySelectorAll('[data-product-card-dot]');
      var prevBtn = card.querySelector('[data-product-card-prev]');
      var nextBtn = card.querySelector('[data-product-card-next]');
      var currentIndex = 0;
      var hoverTimer = null;

      function activateSlide(index) {
        currentIndex = index;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function blurControl(control) {
        if (control && typeof control.blur === 'function') {
          control.blur();
        }
      }

      function stopHoverCycle() {
        if (hoverTimer) {
          clearInterval(hoverTimer);
          hoverTimer = null;
        }
      }

      function startHoverCycle() {
        stopHoverCycle();
        hoverTimer = setInterval(function () {
          activateSlide((currentIndex + 1) % slides.length);
        }, 900);
      }

      card.addEventListener('mouseenter', startHoverCycle);
      card.addEventListener('mouseleave', function () {
        stopHoverCycle();
        activateSlide(0);
      });
      card.addEventListener('focusin', startHoverCycle);
      card.addEventListener('focusout', function (event) {
        if (!card.contains(event.relatedTarget)) {
          stopHoverCycle();
          activateSlide(0);
        }
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          stopHoverCycle();
          activateSlide((currentIndex - 1 + slides.length) % slides.length);
          blurControl(prevBtn);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          stopHoverCycle();
          activateSlide((currentIndex + 1) % slides.length);
          blurControl(nextBtn);
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          stopHoverCycle();
          activateSlide(index);
          blurControl(dot);
        });
      });
    });
  }

  function initCollectionShowMore() {
    var btn = document.querySelector('[data-collection-show-more]');
    var grid = document.querySelector('[data-collection-products]');
    if (!btn || !grid) return;

    var loadingText = btn.dataset.loadingText || 'Loading…';

    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;
      var sectionId = btn.dataset.sectionId;
      if (!nextUrl || btn.disabled) return;

      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var originalText = btn.textContent;
      btn.textContent = loadingText;

      var fetchUrl = new URL(nextUrl, window.location.origin);
      if (sectionId) fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load products');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-products]');
          var newBtn = doc.querySelector('[data-collection-show-more]');

          if (newGrid) {
            newGrid.querySelectorAll('.product-card').forEach(function (card) {
              grid.appendChild(card);
            });
            initProductCards();
          }

          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.textContent = originalText;
          } else {
            btn.closest('.collection-show-more').remove();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
        });
    });
  }

  function initProductAccordion() {
    document.querySelectorAll('[data-product-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('.product-accordion__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('.product-accordion__item').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function initContactAccordion() {
    document.querySelectorAll('[data-contact-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('.contact-accordion__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('.contact-accordion__item').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function formatMoney(cents) {
    var format = window.loyaliceMoneyFormat || '${{amount}}';
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initMiniCart() {
    var root = document.querySelector('[data-mini-cart]');
    if (!root) return;

    var stringsEl = document.querySelector('[data-mini-cart-strings]');
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    var comparePricesEl = document.querySelector('[data-mini-cart-compare-prices]');
    var comparePriceMap = comparePricesEl ? JSON.parse(comparePricesEl.textContent) : {};
    var fetchedProductHandles = {};
    var drawer = root.querySelector('[data-mini-cart-drawer]');
    var titleEl = root.querySelector('[data-mini-cart-title]');
    var itemsEl = root.querySelector('[data-mini-cart-items]');
    var emptyEl = root.querySelector('[data-mini-cart-empty]');
    var footerEl = root.querySelector('[data-mini-cart-footer]');
    var subtotalEl = root.querySelector('[data-mini-cart-subtotal]');
    var savingsRow = root.querySelector('[data-mini-cart-savings-row]');
    var savingsEl = root.querySelector('[data-mini-cart-savings]');
    var totalEl = root.querySelector('[data-mini-cart-total]');
    var discountsEl = root.querySelector('[data-mini-cart-discounts]');
    var promoWrap = root.querySelector('[data-mini-cart-promo]');
    var promoInput = root.querySelector('[data-mini-cart-promo-input]');
    var promoApply = root.querySelector('[data-mini-cart-promo-apply]');
    var promoToggle = root.querySelector('[data-mini-cart-discount-toggle]');
    var headerCount = document.querySelector('[data-cart-count]');
    var openBtns = document.querySelectorAll('[data-cart-open]');
    var closeBtns = root.querySelectorAll('[data-mini-cart-close]');
    var lastFocus = null;
    var isLoading = false;

    function getLineCompareTotal(item) {
      var lineFinal = item.final_line_price || item.line_price;
      var compareAt = comparePriceMap[String(item.variant_id)];

      if (compareAt && compareAt * item.quantity > lineFinal) {
        return compareAt * item.quantity;
      }

      var lineOriginal = item.original_line_price || item.line_price;
      if (lineOriginal > lineFinal) {
        return lineOriginal;
      }

      return lineFinal;
    }

    function getCartCompareSubtotal(cart) {
      return (cart.items || []).reduce(function (sum, item) {
        return sum + getLineCompareTotal(item);
      }, 0);
    }

    function registerVariantComparePrice(variantId, compareAt) {
      if (!variantId) return;
      comparePriceMap[String(variantId)] = compareAt || 0;
    }

    function loadComparePrices(cart) {
      var handlesToFetch = {};

      (cart.items || []).forEach(function (item) {
        if (comparePriceMap[String(item.variant_id)] !== undefined) return;
        if (item.handle) handlesToFetch[item.handle] = true;
      });

      var handles = Object.keys(handlesToFetch).filter(function (handle) {
        return !fetchedProductHandles[handle];
      });

      if (!handles.length) return Promise.resolve();

      handles.forEach(function (handle) {
        fetchedProductHandles[handle] = true;
      });

      return Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .then(function (product) {
            if (!product || !product.variants) return;
            product.variants.forEach(function (variant) {
              registerVariantComparePrice(variant.id, variant.compare_at_price);
            });
          })
          .catch(function () {
            return null;
          });
      }));
    }

    function renderCartWithPrices(cart) {
      return loadComparePrices(cart).then(function () {
        renderCart(cart);
        return cart;
      });
    }

    function translate(key, replacements) {
      var text = strings[key] || '';
      if (!replacements) return text;
      Object.keys(replacements).forEach(function (token) {
        text = text.split(token).join(replacements[token]);
      });
      return text;
    }

    function updateHeaderCount(count) {
      if (!headerCount) return;
      if (count > 0) {
        headerCount.textContent = String(count);
        headerCount.hidden = false;
        headerCount.classList.remove('is-empty');
      } else {
        headerCount.hidden = true;
        headerCount.classList.add('is-empty');
      }
    }

    function openCart() {
      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.body.classList.add('mini-cart-open');
      if (drawer) drawer.focus();
    }

    function closeCart() {
      root.classList.remove('is-open');
      document.body.classList.remove('mini-cart-open');
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 280);
      if (lastFocus) lastFocus.focus();
    }

    function renderItem(item) {
      var lineFinal = item.final_line_price || item.line_price;
      var lineCompare = getLineCompareTotal(item);
      var hasLineDiscount = lineCompare > lineFinal;
      var saveAmount = lineCompare - lineFinal;
      var title = item.product_title || item.title;
      var variantTitle = item.variant_title;
      var displayTitle = title;

      if (variantTitle && variantTitle !== 'Default Title') {
        displayTitle = title + ' (' + variantTitle + ')';
      }

      var saveHtml = '';
      if (hasLineDiscount && saveAmount > 0) {
        saveHtml =
          '<span class="mini-cart__save">' +
          escapeHtml(translate('save', { '__AMOUNT__': formatMoney(saveAmount) })) +
          '</span>';
      }

      var priceHtml = '';
      if (hasLineDiscount) {
        priceHtml +=
          '<s class="mini-cart__price-compare">' + escapeHtml(formatMoney(lineCompare)) + '</s>';
      }
      priceHtml +=
        '<span class="mini-cart__price-current">' + escapeHtml(formatMoney(lineFinal)) + '</span>';

      return (
        '<article class="mini-cart__item" data-mini-cart-item data-line-key="' + escapeHtml(item.key) + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="mini-cart__item-media" tabindex="-1" aria-hidden="true">' +
            (item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="120" height="120">'
              : '<span class="mini-cart__item-placeholder" aria-hidden="true">—</span>') +
          '</a>' +
          '<div class="mini-cart__item-content">' +
            '<a href="' + escapeHtml(item.url) + '" class="mini-cart__item-title">' + escapeHtml(displayTitle) + '</a>' +
            '<div class="mini-cart__item-pricing">' + priceHtml + saveHtml + '</div>' +
            '<div class="mini-cart__item-actions">' +
              '<div class="mini-cart__qty" data-mini-cart-qty>' +
                '<button type="button" class="mini-cart__qty-btn" data-qty-minus aria-label="' +
                  escapeHtml(translate('decrease', { '__PRODUCT__': title })) + '">' +
                  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
                '<span class="mini-cart__qty-value" data-qty-value>' + item.quantity + '</span>' +
                '<button type="button" class="mini-cart__qty-btn" data-qty-plus aria-label="' +
                  escapeHtml(translate('increase', { '__PRODUCT__': title })) + '">' +
                  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 3v8M3 7h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="mini-cart__remove" data-line-remove aria-label="' + escapeHtml(translate('remove')) + '">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
              '<path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7h12z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
        '</article>'
      );
    }

    function renderDiscounts(cart) {
      if (!discountsEl) return;
      var apps = cart.cart_level_discount_applications || [];
      if (!apps.length) {
        discountsEl.hidden = true;
        discountsEl.innerHTML = '';
        return;
      }

      discountsEl.hidden = false;
      discountsEl.innerHTML = apps.map(function (discount) {
        return (
          '<div class="mini-cart__discount-row">' +
            '<span class="mini-cart__discount-label">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12l-8 8-8-8 8-8 8 8z" stroke="currentColor" stroke-width="1.5"/></svg>' +
              escapeHtml(translate('discountApplied', { '__TITLE__': discount.title })) +
            '</span>' +
            '<span class="mini-cart__discount-value">-' + escapeHtml(formatMoney(discount.total_allocated_amount)) + '</span>' +
          '</div>'
        );
      }).join('');
    }

    function renderCart(cart) {
      updateHeaderCount(cart.item_count);

      if (titleEl) {
        titleEl.textContent = translate('title', { '__COUNT__': String(cart.item_count) });
      }

      if (cart.item_count === 0) {
        if (itemsEl) itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (itemsEl) itemsEl.innerHTML = cart.items.map(renderItem).join('');

      var compareSubtotal = getCartCompareSubtotal(cart);

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(compareSubtotal);
      }

      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      if (savingsRow && savingsEl) {
        var totalSavings = compareSubtotal - cart.total_price;
        if (totalSavings > 0) {
          savingsRow.hidden = false;
          savingsEl.textContent = '-' + formatMoney(totalSavings);
        } else {
          savingsRow.hidden = true;
          savingsEl.textContent = '';
        }
      }

      renderDiscounts(cart);
    }

    function fetchCart() {
      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      });
    }

    function refreshCart() {
      return fetchCart().then(function (cart) {
        return renderCartWithPrices(cart);
      });
    }

    function changeLine(key, quantity) {
      if (isLoading) return Promise.resolve();
      isLoading = true;
      root.classList.add('is-loading');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart change failed');
          return response.json();
        })
        .then(function (cart) {
          return renderCartWithPrices(cart);
        })
        .finally(function () {
          isLoading = false;
          root.classList.remove('is-loading');
        });
    }

    function addToCart(variantId, quantity) {
      if (isLoading) return Promise.resolve();
      isLoading = true;
      root.classList.add('is-loading');

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          return refreshCart();
        })
        .then(function () {
          openCart();
        })
        .catch(function (error) {
          var message = (error && error.description) || (error && error.message) || 'Unable to add to cart';
          window.alert(message);
        })
        .finally(function () {
          isLoading = false;
          root.classList.remove('is-loading');
        });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        refreshCart().then(function () {
          openCart();
        });
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeCart);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeCart();
    });

    if (promoToggle && promoWrap) {
      promoToggle.addEventListener('click', function () {
        promoWrap.hidden = !promoWrap.hidden;
        if (!promoWrap.hidden && promoInput) promoInput.focus();
      });
    }

    if (promoApply && promoInput) {
      promoApply.addEventListener('click', function () {
        var code = promoInput.value.trim();
        if (!code) return;
        window.location.href =
          '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    }

    root.addEventListener('click', function (event) {
      var itemEl = event.target.closest('[data-mini-cart-item]');
      if (!itemEl) return;

      var key = itemEl.dataset.lineKey;
      var qtyValue = itemEl.querySelector('[data-qty-value]');
      var currentQty = qtyValue ? parseInt(qtyValue.textContent, 10) : 1;

      if (event.target.closest('[data-line-remove]')) {
        changeLine(key, 0);
        return;
      }

      if (event.target.closest('[data-qty-minus]')) {
        changeLine(key, Math.max(0, currentQty - 1));
        return;
      }

      if (event.target.closest('[data-qty-plus]')) {
        changeLine(key, currentQty + 1);
      }
    });

    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn && addBtn.disabled) return;

        var variantInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('[name="quantity"]');
        if (!variantInput) return;

        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        var variantId = parseInt(variantInput.value, 10);
        var productJsonEl = document.querySelector('[data-product-json]');

        if (productJsonEl) {
          try {
            var productData = JSON.parse(productJsonEl.textContent);
            var selectedVariant = productData.variants.find(function (variant) {
              return variant.id === variantId;
            });
            if (selectedVariant) {
              registerVariantComparePrice(selectedVariant.id, selectedVariant.compare_at_price);
            }
          } catch (error) {
            /* ignore invalid product JSON */
          }
        }

        addToCart(variantId, quantity);
      });
    });

    window.MiniCart = {
      open: function () {
        refreshCart().then(openCart);
      },
      refresh: refreshCart,
      add: addToCart
    };
  }

  function initCartPage() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var updateBtn = form.querySelector('[data-cart-update]');

    form.querySelectorAll('[data-cart-qty]').forEach(function (qtyWrap) {
      var input = qtyWrap.querySelector('[data-qty-input]');
      var minusBtn = qtyWrap.querySelector('[data-qty-minus]');
      var plusBtn = qtyWrap.querySelector('[data-qty-plus]');
      if (!input) return;

      function submitUpdate(nextValue) {
        var value = Math.max(0, nextValue);
        input.value = String(value);
        if (updateBtn) updateBtn.click();
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          submitUpdate(parseInt(input.value, 10) - 1 || 0);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          submitUpdate(parseInt(input.value, 10) + 1 || 1);
        });
      }
    });

    var promoWrap = document.querySelector('[data-cart-promo]');
    if (!promoWrap) return;

    var promoInput = promoWrap.querySelector('[data-promo-input]');
    var promoApply = promoWrap.querySelector('[data-promo-apply]');
    if (!promoInput || !promoApply) return;

    promoApply.addEventListener('click', function () {
      var code = promoInput.value.trim();
      if (!code) return;
      window.location.href =
        '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    });

    promoInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        promoApply.click();
      }
    });
  }

  function initHorizontalCarousel(section, options) {
    var track = section.querySelector(options.track);
    var prev = section.querySelector(options.prev);
    var next = section.querySelector(options.next);
    if (!track || !prev || !next) return;

    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function cardStep() {
      var card = track.querySelector(options.item);
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var canScroll = maxScrollLeft() > 4;
      prev.hidden = !canScroll;
      next.hidden = !canScroll;
      prev.disabled = !canScroll;
      next.disabled = !canScroll;
    }

    prev.addEventListener('click', function () {
      var max = maxScrollLeft();
      if (max <= 4) return;
      if (track.scrollLeft <= 4) {
        track.scrollTo({ left: max, behavior: 'smooth' });
        return;
      }
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      var max = maxScrollLeft();
      if (max <= 4) return;
      if (track.scrollLeft >= max - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initCategoryEditorial() {
    document.querySelectorAll('[data-category-editorial]').forEach(function (section) {
      initHorizontalCarousel(section, {
        track: '[data-category-editorial-track]',
        prev: '[data-category-editorial-prev]',
        next: '[data-category-editorial-next]',
        item: '.category-editorial__card'
      });
    });
  }

  function initFeaturedProductsRow() {
    document.querySelectorAll('[data-featured-products-row]').forEach(function (section) {
      if (section.hasAttribute('data-auto-marquee')) {
        var marquee = section.querySelector('[data-featured-products-marquee]');
        if (!marquee) return;

        section.addEventListener('mouseenter', function () {
          marquee.style.animationPlayState = 'paused';
        });
        section.addEventListener('mouseleave', function () {
          marquee.style.animationPlayState = 'running';
        });
        section.addEventListener('focusin', function () {
          marquee.style.animationPlayState = 'paused';
        });
        section.addEventListener('focusout', function (event) {
          if (!section.contains(event.relatedTarget)) {
            marquee.style.animationPlayState = 'running';
          }
        });
        return;
      }

      initHorizontalCarousel(section, {
        track: '[data-featured-products-track]',
        prev: '[data-featured-products-prev]',
        next: '[data-featured-products-next]',
        item: '.featured-products-row__item'
      });
    });
  }

  function initEmailSubscribeVccoem() {
    var success = document.querySelector('.email-subscribe-vccoem-form__message--success');
    if (success && window.location.hash.indexOf('email-subscribe') !== -1) {
      try {
        success.focus();
      } catch (e) { /* ignore */ }
    }
  }

  function initSpinWheelPopup() {
    var root = document.querySelector('[data-spin-wheel-popup]');
    var fab = document.querySelector('[data-spin-wheel-fab]');
    if (!root || root.dataset.spinWheelBound === 'true') return;
    root.dataset.spinWheelBound = 'true';

    var storageKey = root.getAttribute('data-storage-key') || 'vccoem-spin-wheel-seen-v2';
    var unlockKey = storageKey + '-unlocked';
    var spunKey = storageKey + '-spun';
    var resultKey = storageKey + '-result';
    var fabStorageKey = (fab && fab.getAttribute('data-fab-storage-key')) || 'vccoem-spin-wheel-fab-hidden-v1';
    var readyFromRedirect = false;
    var skipAuto = false;

    try {
      var params = new URLSearchParams(window.location.search);
      readyFromRedirect = params.get('spin_wheel') === 'ready';
      if (readyFromRedirect && window.sessionStorage) {
        sessionStorage.setItem(unlockKey, '1');
      }
    } catch (e) { /* ignore */ }

    try {
      if (!readyFromRedirect && window.sessionStorage && sessionStorage.getItem(storageKey) === '1') {
        skipAuto = true;
      }
    } catch (e) { /* private mode */ }

    var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 15) * 1000;
    var errorFallback = root.getAttribute('data-error-message') || 'Something went wrong. Please try again.';
    var dialog = root.querySelector('[data-spin-wheel-dialog]');
    var wheel = root.querySelector('[data-spin-wheel]');
    var form = root.querySelector('[data-spin-wheel-form]');
    var errorEl = root.querySelector('[data-spin-wheel-error]');
    var submitBtn = root.querySelector('[data-spin-wheel-submit]');
    var submitLabel = root.querySelector('[data-spin-wheel-submit-label]');
    var spinBtn = root.querySelector('[data-spin-wheel-spin]');
    var copyBtn = root.querySelector('[data-spin-wheel-copy]');
    var copiedEl = root.querySelector('[data-spin-wheel-copied]');
    var resultLabel = root.querySelector('[data-spin-wheel-result-label]');
    var resultCode = root.querySelector('[data-spin-wheel-result-code]');
    var resultTitle = root.querySelector('[data-spin-wheel-result-title]');
    var resultHint = root.querySelector('[data-spin-wheel-result-hint]');
    var codeRow = root.querySelector('[data-spin-wheel-code-row]');
    var resultWinTitle = root.getAttribute('data-result-win') || 'You won';
    var resultMissTitle = root.getAttribute('data-result-miss') || 'No prize this time';
    var resultWinHint = root.getAttribute('data-result-hint-win') || '';
    var resultMissHint = root.getAttribute('data-result-hint-miss') || '';
    var segments = [];
    var elapsed = 0;
    var lastTick = 0;
    var timerId = null;
    var opened = false;
    var spinning = false;
    var lastFocused = null;
    var currentRotation = 0;
    var unlocked = false;
    var hasSpun = false;
    var savedResult = null;

    try {
      var jsonEl = root.querySelector('[data-spin-wheel-segments]');
      if (jsonEl) segments = JSON.parse(jsonEl.textContent || '[]');
    } catch (err) {
      segments = [];
    }

    try {
      unlocked = readyFromRedirect || (window.sessionStorage && sessionStorage.getItem(unlockKey) === '1');
    } catch (e) {
      unlocked = readyFromRedirect;
    }

    function readStorage(key) {
      try {
        if (window.sessionStorage && sessionStorage.getItem(key) != null) {
          return sessionStorage.getItem(key);
        }
      } catch (e) { /* ignore */ }
      try {
        if (window.localStorage) return localStorage.getItem(key);
      } catch (e) { /* ignore */ }
      return null;
    }

    function writeStorage(key, value) {
      try {
        if (window.sessionStorage) sessionStorage.setItem(key, value);
      } catch (e) { /* ignore */ }
      try {
        if (window.localStorage) localStorage.setItem(key, value);
      } catch (e) { /* ignore */ }
    }

    try {
      hasSpun = readStorage(spunKey) === '1';
      if (hasSpun) {
        var savedRaw = readStorage(resultKey);
        if (savedRaw) savedResult = JSON.parse(savedRaw);
      }
    } catch (e) {
      hasSpun = false;
      savedResult = null;
    }

    if (!segments.length || !wheel || !dialog) return;

    function markSeen() {
      writeStorage(storageKey, '1');
    }

    function markSpun(prize) {
      hasSpun = true;
      savedResult = {
        label: (prize && prize.label) || '',
        code: ((prize && prize.code) || '').trim()
      };
      writeStorage(spunKey, '1');
      try {
        writeStorage(resultKey, JSON.stringify(savedResult));
      } catch (e) { /* ignore */ }
    }

    function cleanSpinQuery() {
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('spin_wheel')) return;
        url.searchParams.delete('spin_wheel');
        var next = url.pathname + (url.search ? url.search : '') + url.hash;
        window.history.replaceState({}, '', next);
      } catch (e) { /* ignore */ }
    }

    function setStep(name) {
      root.querySelectorAll('[data-spin-wheel-step]').forEach(function (step) {
        var active = step.getAttribute('data-spin-wheel-step') === name;
        step.classList.toggle('is-active', active);
        if (active) {
          step.removeAttribute('hidden');
        } else {
          step.setAttribute('hidden', '');
        }
      });
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || errorFallback;
      errorEl.hidden = !message;
    }

    function showResultUI(prize) {
      var code = ((prize && prize.code) || '').trim();
      var hasPrize = code.length > 0;
      var label = (prize && prize.label) || '';

      if (resultTitle) {
        resultTitle.textContent = hasPrize ? resultWinTitle : resultMissTitle;
      }
      if (resultLabel) {
        resultLabel.textContent = label;
        resultLabel.hidden = !label;
      }
      if (resultCode) resultCode.textContent = code;
      if (codeRow) {
        if (hasPrize) codeRow.removeAttribute('hidden');
        else codeRow.setAttribute('hidden', '');
      }
      if (copyBtn) {
        if (hasPrize) copyBtn.removeAttribute('hidden');
        else copyBtn.setAttribute('hidden', '');
      }
      if (resultHint) {
        resultHint.textContent = hasPrize ? resultWinHint : resultMissHint;
      }
      if (copiedEl) copiedEl.hidden = true;
      if (spinBtn) spinBtn.disabled = true;
    }

    function openPopup() {
      if (opened) return;
      opened = true;
      lastFocused = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        document.body.classList.add('spin-wheel-popup-open');
        if (hasSpun) {
          showResultUI(savedResult || {});
          setStep('result');
          if (dialog) dialog.focus();
        } else if (unlocked) {
          setStep('spin');
          if (spinBtn) {
            spinBtn.disabled = false;
            spinBtn.focus();
          }
        } else {
          setStep('email');
          var emailInput = root.querySelector('[data-spin-wheel-email]');
          if (emailInput) emailInput.focus();
          else if (dialog) dialog.focus();
        }
      });
    }

    function closePopup() {
      markSeen();
      skipAuto = true;
      opened = false;
      root.classList.remove('is-open');
      document.body.classList.remove('spin-wheel-popup-open');
      window.setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 220);
    }

    function pickWeightedIndex() {
      var total = 0;
      segments.forEach(function (seg) {
        total += Math.max(1, parseInt(seg.weight, 10) || 1);
      });
      var roll = Math.random() * total;
      var running = 0;
      for (var i = 0; i < segments.length; i++) {
        running += Math.max(1, parseInt(segments[i].weight, 10) || 1);
        if (roll < running) return i;
      }
      return segments.length - 1;
    }

    function spinToIndex(index) {
      if (spinning || hasSpun) return;
      spinning = true;
      if (spinBtn) spinBtn.disabled = true;

      var count = segments.length;
      var segmentAngle = 360 / count;
      var targetCenter = index * segmentAngle + segmentAngle / 2;
      var spins = 4 + Math.floor(Math.random() * 3);
      var currentMod = ((currentRotation % 360) + 360) % 360;
      var desiredMod = ((360 - targetCenter) % 360 + 360) % 360;
      var delta = (desiredMod - currentMod + 360) % 360;
      if (delta < 1) delta = 360;
      var nextRotation = currentRotation + spins * 360 + delta;
      currentRotation = nextRotation;

      wheel.style.transition = 'transform 4.2s cubic-bezier(0.15, 0.7, 0.1, 1)';
      wheel.style.setProperty('--spin-wheel-rotation', nextRotation + 'deg');

      window.setTimeout(function () {
        wheel.style.transition = 'none';
        wheel.style.setProperty('--spin-wheel-rotation', nextRotation + 'deg');

        var prize = segments[index] || {};
        markSpun(prize);
        showResultUI(prize);
        setStep('result');
        markSeen();
        skipAuto = true;
        spinning = false;
      }, 4300);
    }

    function tick(now) {
      if (opened || skipAuto) return;
      if (!lastTick) lastTick = now;
      if (document.visibilityState === 'visible') {
        elapsed += now - lastTick;
      }
      lastTick = now;

      if (elapsed >= delayMs) {
        openPopup();
        return;
      }
      timerId = window.requestAnimationFrame(tick);
    }

    function initFab() {
      if (!fab) return;

      try {
        if (window.sessionStorage && sessionStorage.getItem(fabStorageKey) === '1') {
          fab.hidden = true;
          return;
        }
      } catch (e) { /* ignore */ }

      fab.hidden = false;

      var dismissBtn = fab.querySelector('[data-spin-wheel-fab-dismiss]');
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startY = 0;
      var originLeft = 0;
      var originTop = 0;
      var posKey = fabStorageKey + '-pos';

      try {
        var saved = window.sessionStorage && sessionStorage.getItem(posKey);
        if (saved) {
          var pos = JSON.parse(saved);
          if (pos && typeof pos.left === 'number' && typeof pos.top === 'number') {
            fab.style.left = pos.left + 'px';
            fab.style.top = pos.top + 'px';
            fab.style.right = 'auto';
            fab.style.bottom = 'auto';
          }
        }
      } catch (e) { /* ignore */ }

      function clampPosition(left, top) {
        var rect = fab.getBoundingClientRect();
        var maxLeft = Math.max(8, window.innerWidth - rect.width - 8);
        var maxTop = Math.max(8, window.innerHeight - rect.height - 8);
        return {
          left: Math.min(maxLeft, Math.max(8, left)),
          top: Math.min(maxTop, Math.max(8, top))
        };
      }

      function onPointerDown(event) {
        if (event.button != null && event.button !== 0) return;
        if (event.target && event.target.closest && event.target.closest('[data-spin-wheel-fab-dismiss]')) return;

        dragging = true;
        moved = false;
        startX = event.clientX;
        startY = event.clientY;
        var rect = fab.getBoundingClientRect();
        originLeft = rect.left;
        originTop = rect.top;

        if (fab.setPointerCapture && event.pointerId != null) {
          try { fab.setPointerCapture(event.pointerId); } catch (err) { /* ignore */ }
        }
      }

      function onPointerMove(event) {
        if (!dragging) return;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;

        // Only treat as a drag after a small threshold so taps still open the wheel.
        if (!moved && Math.abs(dx) <= 6 && Math.abs(dy) <= 6) return;

        if (!moved) {
          moved = true;
          fab.classList.add('is-dragging');
          fab.style.left = originLeft + 'px';
          fab.style.top = originTop + 'px';
          fab.style.right = 'auto';
          fab.style.bottom = 'auto';
        }

        var next = clampPosition(originLeft + dx, originTop + dy);
        fab.style.left = next.left + 'px';
        fab.style.top = next.top + 'px';
        event.preventDefault();
      }

      function onPointerUp(event) {
        if (!dragging) return;
        dragging = false;
        fab.classList.remove('is-dragging');

        if (moved) {
          try {
            if (window.sessionStorage) {
              sessionStorage.setItem(posKey, JSON.stringify({
                left: parseFloat(fab.style.left) || 0,
                top: parseFloat(fab.style.top) || 0
              }));
            }
          } catch (e) { /* ignore */ }
          moved = false;
          return;
        }

        // Tap / click: open the spin wheel.
        if (event.target && event.target.closest && event.target.closest('[data-spin-wheel-fab-dismiss]')) {
          return;
        }
        openPopup();
      }

      fab.addEventListener('pointerdown', onPointerDown);
      fab.addEventListener('pointermove', onPointerMove);
      fab.addEventListener('pointerup', onPointerUp);
      fab.addEventListener('pointercancel', onPointerUp);

      if (dismissBtn) {
        dismissBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          fab.hidden = true;
          try {
            if (window.sessionStorage) sessionStorage.setItem(fabStorageKey, '1');
          } catch (e) { /* ignore */ }
        });
      }
    }

    root.querySelectorAll('[data-spin-wheel-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        closePopup();
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        showError('');
        if (submitLabel && submitBtn) {
          submitLabel.textContent = submitBtn.getAttribute('data-label-loading') || submitLabel.textContent;
        }
      });
    }

    if (spinBtn) {
      spinBtn.addEventListener('click', function () {
        if (hasSpun || spinning) return;
        spinToIndex(pickWeightedIndex());
      });
    }

    if (copyBtn && resultCode) {
      copyBtn.addEventListener('click', function () {
        var code = resultCode.textContent || '';
        if (!code) return;

        var done = function () {
          if (copiedEl) {
            copiedEl.hidden = false;
            window.setTimeout(function () {
              copiedEl.hidden = true;
            }, 1800);
          }
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            done();
          });
        } else {
          done();
        }
      });
    }

    initFab();

    if (hasSpun) {
      // Already used the one allowed spin — no auto popup; FAB can reopen result only.
      cleanSpinQuery();
      skipAuto = true;
      markSeen();
    } else if (unlocked) {
      cleanSpinQuery();
      openPopup();
      setStep('spin');
    } else if (!skipAuto) {
      timerId = window.requestAnimationFrame(tick);
    }
  }

  function initMarketingBanner() {
    document.querySelectorAll('[data-marketing-banner]').forEach(function (banner) {
      var slides = Array.prototype.slice.call(banner.querySelectorAll('[data-marketing-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-marketing-dot]'));
      var prev = banner.querySelector('[data-marketing-prev]');
      var next = banner.querySelector('[data-marketing-next]');
      var index = 0;
      var timer = null;
      var autoplay = banner.getAttribute('data-marketing-autoplay') !== 'false';
      var interval = parseInt(banner.getAttribute('data-marketing-interval'), 10) || 6000;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('hidden');
          } else {
            slide.setAttribute('hidden', '');
          }
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        if (!autoplay || slides.length < 2) return;
        stop();
        timer = setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1);
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
          start();
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-index'), 10) || 0;
          goTo(target);
          start();
        });
      });

      banner.addEventListener('mouseenter', stop);
      banner.addEventListener('mouseleave', start);
      banner.addEventListener('focusin', stop);
      banner.addEventListener('focusout', function (event) {
        if (!banner.contains(event.relatedTarget)) start();
      });

      goTo(0);
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initProductForm();
    initProductGallery();
    initProductAccordion();
    initContactAccordion();
    initCollectionFilters();
    initCollectionSort();
    initMegamenu();
    initAccountModal();
    initProductCards();
    initCollectionShowMore();
    initCartPage();
    initMiniCart();
    initCategoryEditorial();
    initFeaturedProductsRow();
    initMarketingBanner();
    initEmailSubscribeVccoem();
    initSpinWheelPopup();
  });
})();
